import globalStore from 'modules/global-store';
import type { IMenuElement } from './types';

export const useSelectMenu = (): IMenuElement[] => globalStore.get('menu');
